export const fadeUp = {
  hidden: { y: 48, opacity: 0 },
  show: (d = 0) => ({
    y: 0,
    opacity: 1,
    transition: { duration: 0.75, delay: d, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const gridStagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.09, delayChildren: 0.05 } },
};

export const cardEntry = {
  hidden: { y: 50, opacity: 0, scale: 0.97 },
  show: {
    y: 0,
    opacity: 1,
    scale: 1,
    transition: { duration: 0.65, ease: [0.22, 1, 0.36, 1] },
  },
  exit: {
    y: -30,
    opacity: 0,
    scale: 0.97,
    transition: { duration: 0.35, ease: "easeIn" },
  },
};
